import { DocumentSingleIcon } from '@grupoboticario/flora-react-icons';
import { Icon, Link, Text } from 'ui/components/primitives';
import { BOLETO_CONST } from './Boleto.d';
import { Boleto } from './Boleto.styles';
import { cart } from 'core';
import type { BoletoProps } from './Boleto.d';

export const BoletoBase = ({
  deliveryDate,
  expirationDate,
  paymentMethod,
  url,
  value,
  trackUserClicks,
}: BoletoProps) => {
  const { shippingModelType = '' } = cart.hooks.useCartShippingModel();

  const centralPaymentLabel = () => {
    const isPickup = shippingModelType.includes('pickupStore');
    return isPickup ? 'Cartão na retirada do pedido' : 'Cartão no recebimento do pedido';
  };

  return (
    <Boleto.Card data-testid={BOLETO_CONST.TEST_ID}>
      <Boleto.OrderInfo>
        <Text variant="body-large-short">Sobre seu pedido</Text>
        {deliveryDate && (
          <Text variant="auxiliar-small">{`Previsão de entrega: ${deliveryDate}`}</Text>
        )}
        <Text variant="auxiliar-small">{`Valor total do pedido: ${value}`}</Text>
        <Text variant="auxiliar-small">{`Forma de pagamento: ${
          paymentMethod.toLocaleLowerCase().includes('central')
            ? centralPaymentLabel()
            : paymentMethod
        }`}</Text>
        {expirationDate && (
          <Text variant="auxiliar-small">{`Vencimento do boleto: ${expirationDate}`}</Text>
        )}
      </Boleto.OrderInfo>

      {url && (
        <Link to={url} onClick={trackUserClicks}>
          <Boleto.Button stretch>
            Visualizar boleto <DocumentSingleIcon size={12} />
          </Boleto.Button>
        </Link>
      )}
    </Boleto.Card>
  );
};

export default BoletoBase;
